import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { LicenseListState } from './types';

export const getters: GetterTree<LicenseListState, RootState> = {
};
